// caseGroups — API client for sidebar case groups + assignable users.
//
// Groups are per-user collections that organize cases in the sidebar
// (think folders). A case can be in multiple groups.

import apiClient from './client';

export interface CaseGroup {
  id: string;
  name: string;
  user_id: string;
  position: number;
  case_count: number;
  case_ids: string[];
  created_at?: string;
}

export interface AssignableUser {
  id: string;
  username: string;
  full_name: string;
  role: 'analyst' | 'reviewer' | 'operator';
}

export async function listCaseGroups(): Promise<CaseGroup[]> {
  const { data } = await apiClient.get<CaseGroup[]>('/case-groups');
  return data;
}

export async function createCaseGroup(name: string): Promise<CaseGroup> {
  const { data } = await apiClient.post<CaseGroup>('/case-groups', { name });
  return data;
}

export async function renameCaseGroup(id: string, name: string): Promise<CaseGroup> {
  const { data } = await apiClient.put<CaseGroup>(`/case-groups/${id}`, { name });
  return data;
}

export async function deleteCaseGroup(id: string): Promise<void> {
  await apiClient.delete(`/case-groups/${id}`);
}

export async function assignCaseToGroup(groupId: string, caseId: string): Promise<void> {
  await apiClient.post(`/case-groups/${groupId}/cases`, { case_id: caseId });
}

export async function removeCaseFromGroup(groupId: string, caseId: string): Promise<void> {
  await apiClient.delete(`/case-groups/${groupId}/cases/${caseId}`);
}

export async function listAssignableUsers(): Promise<AssignableUser[]> {
  const { data } = await apiClient.get<AssignableUser[]>('/cases/assignable-users');
  return data;
}